import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { emptyValidator } from 'src/app/validator/empty-form-validator';
import { ModalRef } from '../../controls/modal/modal-ref';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { catchError, finalize, of, tap } from 'rxjs';
import { UserInfo } from 'src/app/model/User';

export enum SFTPAuthErrors {
    //can't connect to SFTP site
    ConnectionError = "ConnectionError",
    //entered wrong SFTP user name or password
    InvalidUsernameOrPassword = "InvalidUsernameOrPassword",
    //entered wrong Proxy user name or password
    InvalidProxyUsernameOrPassword = "InvalidProxyUsernameOrPassword",
    //can't connect to SFTP site via proxy
    ProxyConnectionError = "ProxyConnectionError",
    //no error
    NoError = "NoError",
  }

@Component({
  selector: 'app-settings-support-sftpauth',
  templateUrl: './settings-support-sftpauth.component.html',
  styleUrl: './settings-support-sftpauth.component.css',
  standalone: false
})
export class SettingsSupportSFTPAuthComponent implements OnInit {

  processing: boolean = false;
  isProxyAuthRequired: boolean = false;
  title:string = '';
  SFTPAuthErrors = SFTPAuthErrors;
  errorState:SFTPAuthErrors = SFTPAuthErrors.NoError;

  loginForm = new FormGroup({
    username: new FormControl('', [
      Validators.required, emptyValidator()
    ]),
    password: new FormControl('', [
      Validators.required
    ]),
    proxyUsername: new FormControl('', []),
    proxyPassword: new FormControl('', [])
  });

  constructor(private modalRef: ModalRef, public authService: AuthenticationService){
  }

  ngOnInit(): void {
    this.title = $localize`Sign in to OpenText My Support`;
    const user: UserInfo = this.authService.getLoggedInUser();
    this.isProxyAuthRequired = user.settings.proxyPrompt;

    if(this.isProxyAuthRequired){
      this.proxyUsernameCtrl.setValidators([Validators.required, emptyValidator()]);
      this.proxyPasswordCtrl.setValidators([Validators.required]);
    }else{
      this.proxyUsernameCtrl.clearValidators();
      this.proxyPasswordCtrl.clearValidators();
    }
  }

  get proxyUsernameCtrl() { return this.loginForm.get('proxyUsername');}
  get proxyPasswordCtrl() { return this.loginForm.get('proxyPassword');}

  onClose(): void {
    this.modalRef.close(false);
  }

  onSubmit(): void {
    this.processing = true;
    this.errorState = SFTPAuthErrors.NoError;
    
    this.authService.connectToSFTP(this.loginForm.value.username, this.loginForm.value.password, this.loginForm.value.proxyUsername, this.loginForm.value.proxyPassword).pipe(
      tap(resp => {
        this.modalRef.close(true);
      }),
      catchError(resp => {
        if (resp.status === 401) {
          this.errorState = SFTPAuthErrors.InvalidUsernameOrPassword;
        } else if (resp.status === 511) {
          this.errorState = SFTPAuthErrors.InvalidProxyUsernameOrPassword;
        } else if (resp.status === 599) {
          this.errorState = SFTPAuthErrors.ProxyConnectionError;
        } else {
          this.errorState = SFTPAuthErrors.ConnectionError;
        }
        return of(resp);
      }),
      finalize(() => {
        this.processing = false;
      })
    ).subscribe();
  }
}
